export default __webpack_public_path__ + "static/TrustAlice-Background2-e890568a11dede4a799b3b9f0cf53c78.jpg";